/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchSupportFlowRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SearchSupportFlowResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const searchSupportFlow = (request:SearchSupportFlowRequest, options?: CashRequestOptions) => post<SearchSupportFlowRequest, SearchSupportFlowResponse>("/2.0/cash/search-support-flow", request, {...options, rejectOnError: true })